import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';

@Component({
  selector: 'app-banner',
  imports: [
    TextModule,
    IconModule,
    PipesModule,
  ],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('closed', style({
        transform: 'translateX(calc(-100% - 30px))',
      })),
      state('opened', style({
        transform: 'translateY(0)',
      })),
      transition('closed <=> opened', animate('150ms ease-in-out')),
    ]),
  ],
})
export class BannerComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);

  selectedStation = this.weathermapFacade.selectedStation;

  state: 'opened' | 'closed';

  bannerLink = 'https://www.netatmo.com/weather-station-original';

  @HostBinding('@slideInOut') get slideInOut(): string {
    return this.selectedStation() ? 'closed' : 'opened';
  }
}
